import { FirefoxError } from '../errors/firefox';

export const isFirefoxError = (error: Error): error is FirefoxError => {
  const maybeFirefoxError = error as FirefoxError;

  return (
    maybeFirefoxError.fileName !== undefined ||
    maybeFirefoxError.lineNumber !== undefined ||
    maybeFirefoxError.columnNumber !== undefined
  );
};
